import { ReactNode } from 'react'

interface MasterDetailLayoutProps {
  list: ReactNode
  detail: ReactNode
  emptyDetail?: ReactNode
  hasSelection?: boolean
  className?: string
}

export function MasterDetailLayout({
  list,
  detail,
  emptyDetail,
  hasSelection = false,
  className = '',
}: MasterDetailLayoutProps) {
  return (
    <div className={`master-detail ${className}`}>
      <div className="master-detail__list">{list}</div>
      <div className="master-detail__detail">
        {hasSelection ? detail : emptyDetail || <MasterDetailEmptyState />}
      </div>
    </div>
  )
}

function MasterDetailEmptyState() {
  return (
    <div className="master-detail__empty">
      <p>Selecciona un elemento para ver los detalles</p>
    </div>
  )
}
